import merge from "lodash/merge";
import axios from "axios";
import { API_URL } from "../../urlConfig";

export const API_ROOT = "/api";

const _ = require("lodash");
const moment = require("moment");

const getFullUrl = endpoint => {
  return `${API_URL}${API_ROOT}${endpoint}`;
};

export const get = (endpoint, options = {}) => {
  let token = window.localStorage.getItem("app.Authorization");
  let account = window.localStorage.getItem("app.Account");

  if (isNaN(account)) {
    window.localStorage.setItem("app.Account", "");
  }
  let apiOptions = merge(options, {
    headers: {
      Accept: "application/vnd.api+json",
      Authorization: `Bearer ${token}`,
      Account: isNaN(account) ? undefined : account
    }
  });

  return axios.get(getFullUrl(endpoint), apiOptions);
};

export const patch = (endpoint, data, options = {}) => {
  let token = window.localStorage.getItem("app.Authorization");
  let account = window.localStorage.getItem("app.Account");

  let apiOptions = merge(options, {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
      Authorization: `Bearer ${token}`,
      Account: isNaN(account) ? undefined : account
    }
  });

  return axios.patch(getFullUrl(endpoint), data, apiOptions);
};

export const post = (endpoint, data, options = {}) => {
  let token = window.localStorage.getItem("app.Authorization");
  let account = window.localStorage.getItem("app.Account");

  let apiOptions = merge(options, {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
      Authorization: `Bearer ${token}`,
      Account: isNaN(account) ? undefined : account
    }
  });

  return axios.post(getFullUrl(endpoint), data, apiOptions);
};

export const postForm = (endpoint, data, options = {}) => {
  let token = window.localStorage.getItem("app.Authorization");
  let account = window.localStorage.getItem("app.Account");
  let apiOptions = merge(options, {
    headers: {
      Accept: "multipart/form-data",
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${token}`,
      Account: isNaN(account) ? undefined : account
    }
  });

  return axios.post(getFullUrl(endpoint), data, apiOptions);
};

export const destroy = (endpoint, data, options = {}) => {
  let token = window.localStorage.getItem("app.Authorization");
  let account = window.localStorage.getItem("app.Account");

  let apiOptions = merge(options, {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
      Authorization: `Bearer ${token}`,
      Account: isNaN(account) ? undefined : account
    }
  });
  return axios.delete(getFullUrl(endpoint), {
    headers: apiOptions.headers,
    data: data.data
  });
};

export const download = (endpoint, data, options = {}) => {
  let token = window.localStorage.getItem("app.Authorization");

  let apiOptions = merge(options, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return axios.get(getFullUrl(endpoint), {
    headers: apiOptions.headers
  });
};

const { isObject, isArray, pickBy, compact, identity, mapValues } = _;
const mapValuesDeep = (obj, cb) => {
  if (isArray(obj)) {
    return obj.map(innerObj => mapValuesDeep(innerObj, cb));
  } else if (moment.isMoment(obj)) {
    return cb(obj.format()); //"YYYY-MM-DDTHH:mm:ss"
  } else if (isObject(obj)) {
    return mapValues(obj, val => mapValuesDeep(val, cb));
  } else {
    return cb(obj);
  }
};
const normaliseNull = obj => {
  let value =
    obj !== undefined && obj !== ""
      ? moment.isMoment(obj)
        ? obj.format()
        : obj
      : null;
  return value;
};

class ApiService {
  downloadFile(url) {
    return download(url);
  }

  baseSave(model, item) {
    // TODO: extract this out to a more general use model parsing function
    //delete item["relationships"];
    //delete item["links"];

    let keysToDelete = [];
    Object.entries(item).forEach(([key, value]) => {
      if (
        key !== "id" &&
        key !== "type" &&
        key !== "attributes" &&
        key !== "user" &&
        key !== "supportUser"
      ) {
        keysToDelete.push(key);
      }
    });

    keysToDelete.map(key => delete item[key]);
    //
    item = mapValuesDeep(item, normaliseNull);
    item.type = _.camelCase(model);
    // TODO: wrap this, along with PUT/POST methods into a general save function, that can check for an id and contruct a url/use the correct method based on the model
    if (item.id) {
      return patch(`/${model}/${item.id}`, {
        data: item
      });
    } else {
      delete item["id"];
      return post(`/${model}/`, { data: item });
    }
  }

  baseArchive(model, item) {
    delete item["links"];
    delete item["relationships"];
    delete item["attributes"];
    return destroy(`/${model}/${item.id}`, { data: item });
  }
}

export default ApiService;



// WEBPACK FOOTER //
// ./src/services/apiService/index.js